import { defineAgenda, param } from '@/shared/navigation/core';
import { SERIE_TAB_KEYS } from '../internal/serieLayers';

/**
 * Agenda detailu jednoho termínu. Otevírá se prokликem ze seznamu termínů na detailu seriálu nebo editačním
 * tlačítkem v treeview kalendáře. Potřebuje productId + serieId + termId, aby odpovídala backendovému kontraktu
 * `/products/{productId}/series/{serieId}/terms/{termGroupId}`.
 */
export const termDetailAgenda = defineAgenda({
  id: 'app.venua-planner.term-detail',
  path: 'app/venua-planner/term-detail',
  open: {
    productId: param.uuid(),
    serieId: param.uuid(),
    termId: param.uuid(),
  },
  state: {
    // Zvolená záložka (vrstva dat). V URL, aby reload zůstal na stejné záložce; při otevření ji lze
    // předat jako počáteční `state` (odkaz ze sidebaru kalendáře) nebo převzít z předchozího detailu.
    tab: param.enum(SERIE_TAB_KEYS).optional(),
    // Rozbalený termín v tabulce na záložce Yield Management (stejná komponenta jako u seriálu).
    calcTermId: param.uuid().optional(),
  },
  title: 'Detail termínu',
  icon: 'users',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
